import { getBoardResultsData } from "@/helpers/api/service";
import Result from "@/components/Results/Results";
import ToppersTalk from "@/components/Results/ToppersTalk";
import { TestimonialItem } from "@/components/Testimonial/TestimonialItem";
import Image from "next/image";
import Shimmer from "@/utils/shimmer";
import { IResultsData } from "@/components/Results/interfaces";
import Pills from "@/components/Pills";
import { STATIC_CDN_IMAGES } from "@/config/constants";
import Socials from "@/components/Socials";
import MetaSeo from "@/components/Head/Meta";

const Results = ({ data }: { data: any }) => {

  return (
    <>
      <MetaSeo title="Doubtnut Results" description="Discover the remarkable results of our students from UP & Bihar boards studying in Hindi medium at Doubtnut. Witness their academic success stories and see how our online coaching platform can help you excel in your studies. Start your journey with us today." />

      {/* hero container */}
      <div className="body-fluid mt-0 px-0">
        {/* hero section */}
        <div className='flex justify-center px-0'>
          <div className="relative grow text-center">
            <Image
              src={`${STATIC_CDN_IMAGES}/web-result-page-hero.webp`}
              className='brightness-[30%] w-full h-full sm:h-[50vh] aspect-video object-cover object-top  my-0'
              alt={""}
              placeholder='blur'
              width={85}
              height={85}
              blurDataURL={Shimmer(600, 400)}
            />
            <div className='absolute top-0 w-full h-full flex flex-col justify-center'>
              <h1 className='text-white mb-4'>
                <span> {data.title} </span><br />
                <span className="text-xl">{data.subtitle}</span>
                <hr className='border-2 border-accent mx-auto w-64 sm:w-96 my-2' />
                <span className="text-xl">{data.subtitle2}</span>
              </h1>
            </div>
          </div>
        </div>
      </div>

      <div className="body-content">
        {/* <div className="hidden sm:block w-full relative">
          <Socials className="absolute -ml-12 mt-16" />
        </div> */}
        {/* toppers talk section */}
        <section className='text-center'>
          <h3 className='text-center'>
            Toppers Talk
          </h3>
          <ToppersTalk items={data.testimonials_video} />
        </section>

        {/* pill section  */}
        <section className='text-center flex justify-center items-center'>
          <Pills items={Object.keys(data.toppers ? data.toppers : {}).map((item) => ({ text: item, href: `#${item}`, type: "pillBorder" }))} overflow />
        </section>

        {/* toppers result section */}
        {Object.entries(data.toppers ? data.toppers : {}).map(([key, value], index) => (
          <section className='text-center' id={`${key}`} key={key}>
            <h3 className='text-center'>
              {key}
            </h3>
            <Result items={value as IResultsData[]} />
          </section>
        ))}


        {/* text messages */}
        <section className='text-center mb-10 sm:mb-20 scroll-mt-12'>
          <h3 className='text-center'>
            See what our students say about us
          </h3>
          <div className='flex flex-col md:flex-row  gap-5 text-center overflow-x-auto snap-x snap-proximity'>
            {data.testimonials_text?.map((msg: any, index: number) => (
              <TestimonialItem
                key={index}
                user={{
                  imageUrl: "",
                  name: msg.name,
                  description: msg.text_content,
                }}
                index={index}
              />
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

// This function gets called at build time on server-side.
// It won't be called on client-side, so you can even do
// direct database queries.
export async function getStaticProps(ctx: any) {
  // Call an external API endpoint to get posts.
  // You can use any data fetching library
  const res = await getBoardResultsData();
  const posts = res.data;

  // By returning { props: { posts } }, the Blog component
  // will receive `posts` as a prop at build time
  return {
    props: {
      data: posts ? posts : {},
    },
  };
}

export default Results;
